export * from "./ErrorHandler";

export const emptyUtils = "";

export const stripHtml = (str?: string) => {
  if (!str) return "";
  return str.replace(/<[^>]+>/g, "");
};
